<template>
  <div class="ticket-info">
      <div>
        <p class="ticket-amount">The pre-sale has ended.</p>
        <p>Please present your ID for entrance to the festival if you have a pre-sale ticket.</p>
        <!--<p>Festival ticket + afterparty via PayPal: <span class="ticket-amount">20€</span></p>-->
        <p>Festival ticket + afterparty on the door: <span class="ticket-amount">25€</span></p>
        <p>Afterparty ticket on the door: <span class="ticket-amount">10€</span></p>
        <!--<p>Physical tickets sold in music shop Terminal (<a href="https://goo.gl/maps/ED7NeFdLPkaVEX4m7" target="_blank" style="color: white;">Rävala pst 6, Tallinn</a> (open Mo-Sa 12-20))</p>-->
      </div>
<!--      <form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post" >
        <input type="hidden" name="cmd" value="_cart">
        <input type="hidden" name="business" value="info@bodymachinebody.com">
        <input type="hidden" name="lc" value="EE">
        <input type="hidden" name="item_name" value="Body Machine Body festival ticket">
        <input type="hidden" name="amount" value="20">
        <input type="hidden" name="currency_code" value="EUR">
        <input type="hidden" name="button_subtype" value="products">
        <input type="hidden" name="no_note" value="0">
        <input type="hidden" name="add" value="1">
        <input type="hidden" name="bn" value="PP-ShopCartBF:btn_cart_LG.gif:NonHostedGuest">
      </form>
      <div class="ticket-button" style=""><a class="button-text" onclick="document.forms[0].submit()"><p style="font-size: 16px;">BUY TICKET VIA PAYPAL</p></a></div>-->

  </div>
</template>

<script>
  export default {
    name: "Tickets"
  }
</script>

<style scoped>
  .ticket-info {
    background-color: #0d2f39;
    width: 70%;
    margin: 30px auto 50px;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    align-content: center;
    color: #cdcdcd;
  }

  .ticket-amount {
    font-weight: bolder;
    color: white;
  }

  .ticket-button {
    width: 50%;
    margin: 20px 0 30px;
    border: 3px solid white;
    cursor: pointer;
    align-content: center;
    border-radius: 3px;
    transition: transform .2s;
  }

  .ticket-button:hover {
    box-shadow: 0 1px 20px rgba(21, 25, 34, 0.8);
    transform: scale(1.01, 1.01);
  }

  @media (max-width: 425px) {
    .ticket-button {
      width: 100%;
    }
  }
</style>